module.exports = __webpack_public_path__ + "static/img/195_TO8_2094.dfcb4e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/195_TO8_2094.jpg
// module id = fPX2
// module chunks = 0